const getInternalLinkURLWithoutDuplicatedForwardSlash = (url: InternalLinkURL): InternalLinkURL =>
  url.replace(/(\/)\/+/g, '$1');

export default getInternalLinkURLWithoutDuplicatedForwardSlash;
